import { render } from "./ActualitePostePage.vue?vue&type=template&id=fa843f9a"
import script from "./ActualitePostePage.vue?vue&type=script&lang=js"
export * from "./ActualitePostePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__